import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "game-gui" }
const _hoisted_2 = {
  key: 0,
  class: "showing-scores"
}
const _hoisted_3 = {
  key: 0,
  class: "game-over-header"
}
const _hoisted_4 = { class: "scores" }
const _hoisted_5 = { class: "score_text" }
const _hoisted_6 = { class: "score_text_name" }
const _hoisted_7 = {
  key: 1,
  class: "new-round"
}
const _hoisted_8 = {
  key: 2,
  class: "choosing-word"
}
const _hoisted_9 = {
  key: 0,
  class: "word-choices"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, "Choose a word to draw", -1)
const _hoisted_11 = { class: "words" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = {
  key: 1,
  class: "drawer-is-choosing-word"
}
const _hoisted_14 = { class: "game-gui_scores" }
const _hoisted_15 = { class: "game-gui_scores_score_number" }
const _hoisted_16 = ["id"]
const _hoisted_17 = {
  key: 0,
  class: "game-gui_scores_score_drawing"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pencil-alt" }, null, -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = { class: "game-gui_grid" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_22 = { class: "game-gui_timer" }
const _hoisted_23 = {
  key: 0,
  class: "game-gui_timer_rounds"
}
const _hoisted_24 = {
  key: 1,
  class: "game-gui_timer_remaining-time"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_26 = { class: "game-gui_selections" }
const _hoisted_27 = { class: "game-gui_selections_brushs" }
const _hoisted_28 = { class: "game-gui_selections_colors" }
const _hoisted_29 = { class: "game-gui_canvas" }
const _hoisted_30 = { class: "game-gui_chat" }
const _hoisted_31 = {
  key: 0,
  class: "game-gui_word"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_avatar = _resolveComponent("avatar")!
  const _component_BrushSelector = _resolveComponent("BrushSelector")!
  const _component_ColorSelector = _resolveComponent("ColorSelector")!
  const _component_drawing_canvas = _resolveComponent("drawing-canvas")!
  const _component_chat = _resolveComponent("chat")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showingScores)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.game.isOver)
            ? (_openBlock(), _createElementBlock("p", _hoisted_3, "Game over!"))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.game.players.sort((a, b) =>
            _ctx.game.isOver
              ? b.score - a.score
              : b.lastPointsAdded - a.lastPointsAdded
          ), (player) => {
              return (_openBlock(), _createElementBlock("div", {
                key: player.id,
                class: "score"
              }, [
                _createVNode(_component_avatar, {
                  size: 45,
                  username: player.name
                }, null, 8, ["username"]),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, _toDisplayString(player.name), 1),
                  _createElementVNode("div", {
                    class: _normalizeClass(["score_text_number", {
                plain: _ctx.game.isOver || !player.lastPointsAdded,
                subtracting:
                  (!_ctx.game.isOver && player.lastPointsAdded < 0) ||
                  (_ctx.game.isOver && player.score < 0),
              }])
                  }, _toDisplayString(_ctx.game.isOver ? "" : player.lastPointsAdded >= 0 ? "+" : "-") + " " + _toDisplayString(_ctx.game.isOver
                  ? player.score
                    ? player.score
                    : 0
                  : player.lastPointsAdded
                  ? Math.abs(player.lastPointsAdded)
                  : 0), 3)
                ])
              ]))
            }), 128))
          ]),
          (_ctx.game.isOver && _ctx.isClientGameCreator)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "btn",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('restart-game')))
              }, " Return to lobby "))
            : _createCommentVNode("", true)
        ]))
      : (_ctx.showingNewRound)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, " Round " + _toDisplayString(_ctx.game.currentRound), 1))
        : (_ctx.game.currentWord === '')
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              (_ctx.isClientGameDrawer)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _hoisted_10,
                    _createElementVNode("div", _hoisted_11, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.game.wordChoices, (word) => {
                        return (_openBlock(), _createElementBlock("button", {
                          key: word,
                          class: "word",
                          onClick: ($event: any) => (_ctx.$emit('word-selected', word))
                        }, _toDisplayString(word), 9, _hoisted_12))
                      }), 128))
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("p", null, _toDisplayString(_ctx.game.drawer.name) + " is choosing a word...", 1)
                  ]))
            ]))
          : _createCommentVNode("", true),
    (!_ctx.game.isOver)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
          _createElementVNode("div", _hoisted_14, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.game.players.sort((a, b) => b.score - a.score), (player) => {
              return (_openBlock(), _createElementBlock("div", {
                key: player.id,
                class: "game-gui_scores_score"
              }, [
                _createVNode(_component_avatar, {
                  class: _normalizeClass(["game-gui_scores_score_avatar", { correct: player.answeredCorrectly }]),
                  size: 50,
                  username: player.name,
                  backgroundColor: "#725ac1"
                }, null, 8, ["class", "username"]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("p", {
                    id: 'gui_scores_score_number_' + player.id
                  }, _toDisplayString(player.score ? player.score : 0), 9, _hoisted_16)
                ]),
                (_ctx.game.drawer.id === player.id)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_19))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            _createElementVNode("div", _hoisted_22, [
              (_ctx.game.currentRound && _ctx.game.rounds)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, " Round " + _toDisplayString(_ctx.game.currentRound) + " / " + _toDisplayString(_ctx.game.rounds), 1))
                : _createCommentVNode("", true),
              (_ctx.formattedRemainingTime)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(_ctx.formattedRemainingTime), 1))
                : _createCommentVNode("", true)
            ]),
            _hoisted_25,
            _createElementVNode("div", _hoisted_26, [
              (_ctx.isClientGameDrawer)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_27, [
                      _createVNode(_component_BrushSelector, {
                        brushSize: _ctx.brushSize,
                        brushTool: _ctx.brushTool,
                        onBrushSizeSelection: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setBrushSize($event))),
                        onBrushToolSelection: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setBrushTool($event)))
                      }, null, 8, ["brushSize", "brushTool"])
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                      _createVNode(_component_ColorSelector, {
                        selectedColor: _ctx.canvasColor,
                        onColorSelection: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setColor($event)))
                      }, null, 8, ["selectedColor"])
                    ])
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createVNode(_component_drawing_canvas, {
                canvasSrc: _ctx.isClientGameDrawer ? '' : _ctx.canvasSrc,
                clearCanvasKey: _ctx.clearCanvasKey,
                color: _ctx.canvasColor,
                brushSize: _ctx.brushSize,
                brushTool: _ctx.brushTool,
                disabled: !_ctx.isClientGameDrawer,
                onSendCanvasData: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('send-canvas-data', $event)))
              }, null, 8, ["canvasSrc", "clearCanvasKey", "color", "brushSize", "brushTool", "disabled"])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createVNode(_component_chat, {
                messages: _ctx.game.messages,
                onSendMessage: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('send-message', $event)))
              }, null, 8, ["messages"])
            ]),
            (_ctx.game.currentWord !== '')
              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.game.currentWord.split(" ").join(" ")), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}